
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/catbus/ui/features/wiki-page-index/jst/WikiPageIndexEditDialog';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function";


  buffer += "<div class=\"edit-content\">\n  <label class=\"edit-label\" for=\"title\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_index_edit_dialog")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_index_edit_dialog.page_title", "Title", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_index_edit_dialog.page_title", "Title", options)))
    + "</label>\n  <div class=\"edit-controls\">\n    <input class=\"edit-control-text\" type=\"text\" id=\"title\" name=\"title\" value=\"";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n  </div>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  